import { useDispatch, useSelector } from "react-redux";
import "./RolePlayDetailComponent.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  fetchRolePlayData,
  fetchRolePlayDataClear,
  getRolePlayRecordedDetail,
  getRolePlayRecordedDetailClear,
} from "../../../redux/roleplay/actions";
import _ from "lodash";
import DetailPageBannerHeaderComponent from "../DetailPage/DetailPageBannerHeader/DetailPageBannerHeaderComponent";
import NotFoundComponent from "../NotFound/NotFoundComponent";
import BreadCrumbComponent from "../Misc/BreadCrumb/BreadCrumbComponent";
import { SessionKeys } from "../../../utils/AppUtils";
import Loader from "../../Loader/Loader";
import RPDetailBodyComponent from "./RPDetailBodyComponent/RPDetailBodyComponent";
import RPReviewDetailBodyComponent from "./RPReviewDetailBodyComponent";
import ConfirmModal from "../../modal/ConfirmModal";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import { useTranslation } from "react-i18next";
const RolePlayReviewDetailComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { roleplayId } = useParams();

  const [rubricData, setRubricData] = useState([]);
  const { t } = useTranslation();
  const rpDetailData = useSelector((state) => state.rolePlay.recordedDetail);
  const rpWpData = useSelector((state) => state.rolePlay.rolePlayData);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  useEffect(() => {
    console.log("rpwpDa", rpWpData);
    if (!_.isEmpty(rpWpData)) {
      if (rpWpData?.status === "success") {
        setRubricData(rpWpData?.payload?.payload?.rubric_data);
      }
    }
  }, [rpWpData]);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const type = params.get("type");
  const submit_id = params.get("submit_id");
  // let decodedString = atob(c);
  // let paramsReq = JSON.parse(decodedString);

  const title = "";
  const id = "";
  const logoURL = "";
  const logoAltText = "";
  const description = "";
  const bannerURL = "";
  const videoURL = "";
  const instruction = "";
  const positiveValue = "";
  const negativeValue = "";
  const neutralValue = "";
  const analytics = "";
  const duration = "";
  const add_comments = "";
  const status = "";
  const feedback = "";

  const convertTimeFormat = (timeString) => {
    const [minutes, seconds] = timeString.split(":");
    return `${minutes}m ${seconds}s`;
  };

  const [roleplayDetail, setRoleplayDetail] = useState("");
  const [tagsArray, setTagsArray] = useState([]);
  const [headerProdData, setHeaderProdData] = useState({});

  useEffect(() => {
    if (!_.isEmpty(rpDetailData)) {
      console.log("rpde---", rpDetailData);
      if (rpDetailData?.status === "success") {
        let tagsArray = [];
        if (rpDetailData?.payload?.payload?.provider) {
          tagsArray.push(
            rpDetailData?.payload?.payload?.provider?.display_name
          );
        }
        tagsArray.push("Role play");
        tagsArray.push(
          rpDetailData?.payload?.payload?.uploaded_type === "audio"
            ? "Audio"
            : "Video"
        );
        tagsArray.push(
          convertTimeFormat(rpDetailData?.payload?.payload?.recorded_duration)
        );
        // let tagsArray = [

        //   "Video",
        //   convertTimeFormat(rpDetailData?.payload?.payload?.recorded_duration),
        // ];
        setTagsArray(tagsArray);
        // alert(JSON.stringify(rpDetailData.payload.payload))
        setRoleplayDetail(rpDetailData?.payload?.payload);
        setRubricData(rpDetailData?.payload?.payload?.rubric_data);
        setBreadCrumbData([
          {
            name: "Learn",
            active: false,
            link: "/learn/courses?tab=1",
            isLoading: false,
          },
          {
            name: "Role play",
            active: false,
            link: "/learn/roleplay?tab=1",
            isLoading: false,
          },
          {
            name: type === "reviewe" ? "My role plays" : "To review",
            active: false,
            link:
              type === "reviewe"
                ? "/learn/roleplay?tab=2"
                : "/learn/roleplay?tab=3",
            isLoading: false,
          },
          {
            name: rpDetailData?.payload?.payload?.title,
            active: true,
            link: "",
            isLoading: false,
          },
        ]);

        setIsLoading(false);
      }
      dispatch(fetchRolePlayDataClear());
      dispatch(getRolePlayRecordedDetailClear());
    }
  }, [rpDetailData]);

  const fetchRolePlayDetail = () => {
    dispatch(
      fetchRolePlayData({
        module: "getRolePlayDetail",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: roleplayId,
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  useEffect(() => {
    console.log("data--", rpWpData);
    if (!_.isEmpty(rpWpData)) {
      if (rpWpData.status === "success") {
        const payload = rpWpData.payload.payload;
        // if (type != 'review')
        dispatch(
          getRolePlayRecordedDetail({
            module: "getroleplayrecordeddetail",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              id: payload?.rp_mid,
              type: type,
              submit_id: submit_id,
            },
          })
        );
        return () => {
          dispatch(getRolePlayRecordedDetailClear());
          dispatch(fetchRolePlayDataClear());
        };
      }
    }
  }, [rpWpData]);

  useEffect(() => {
    // dispatch(
    //   getRolePlayRecordedDetail({
    //     module: "getroleplayrecordeddetail",
    //     postData: {
    //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //       id: roleplayId,
    //       type: type,
    //     },
    //   })
    // );
    // return () => {
    //   dispatch(getRolePlayRecordedDetailClear());
    // };
    fetchRolePlayDetail();
  }, [roleplayId, activeLanguage]);

  const [isLoading, setIsLoading] = useState(true);
  const [rpDetail, setRPDetail] = useState({
    bannerURL: bannerURL,
    videoURL: videoURL,
    instruction: instruction,
    title: title,
    positiveValue: positiveValue,
    negativeValue: negativeValue,
    neutralValue: neutralValue,
    analytics: analytics,
    tagsArray: ["Roleplay", "Video", convertTimeFormat(duration)],
    addComments: add_comments,
    status: status,
    feedback: feedback,
  });
  const [breadCrumbData, setBreadCrumbData] = useState([
    {
      name: "Learn",
      active: false,
      link: "/learn/courses?tab=1",
      isLoading: false,
    },
    {
      name: "Role play",
      active: false,
      link: "/learn/roleplay?tab=1",
      isLoading: false,
    },
    {
      name: "To Review",
      active: false,
      link: "/learn/roleplay?tab=3",
      isLoading: false,
    },
    { name: roleplayDetail?.title, active: true, link: "", isLoading: false },
  ]);

  const [showModalMsg, setShowModalMsg] = useState({
    error: false,
    message: "",
  });
  const [confirmModal, setConfirmModal] = useState(false);
  const [showGreenTick, setShowGreenTick] = useState(false);

  console.log("ROLEPLAY ID", roleplayId);

  // useEffect(() => {
  //   if (roleplayDetail) {
  //     fetchRolePlayDetail(roleplayDetail?.reference_id);
  //   }
  // }, [roleplayDetail]);

  const navigateToListing = () => {
    navigate("/learn/roleplay");
  };

  const renderAlertCard = () => {
    return (
      <div
        className={`alert-card d-flex justify-content-center ${
          confirmModal ? "" : "d-none"
        }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            {!showModalMsg.error ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <g
                  id="Group_5699"
                  data-name="Group 5699"
                  transform="translate(0.498 0.498)"
                >
                  <circle
                    id="Ellipse_222"
                    data-name="Ellipse 222"
                    cx="9"
                    cy="9"
                    r="9"
                    transform="translate(-0.498 -0.498)"
                    fill="#A9C23C"
                  />
                  <path
                    id="Icon_material-done"
                    data-name="Icon material-done"
                    d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z"
                    transform="translate(-3.013 -6.071)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                </g>
              </svg>
            ) : (
              ""
            )}
            <p className="m-0">{showModalMsg.message}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setConfirmModal(false);
                setShowModalMsg({ error: false, message: "" });
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };
  const [loaderMsg, setLoaderMsg] = useState("");

  return (
    <>
      <Loader
        start={
          sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES"
            ? false
            : isLoading
        }
        msg={loaderMsg}
      />
      {!isLoading &&
      _.isEmpty(roleplayDetail) &&
      sessionStorage.getItem(SessionKeys.IS_TOUR) !== "YES" ? (
        <NotFoundComponent
          btnAction={() => navigateToListing()}
          btnName={"Explore Role play"}
          showMsg={true}
          showBtn={true}
          width={400}
          height={419}
        />
      ) : (
        <>
          <div class="bannersection bgba">
            {false && (
              <DetailPageBannerHeaderComponent
                tagLine={"Free for you"}
                bannerURL={""}
                btnName=""
                productData={rpDetail}
                showTagLine={true}
                showShareIcon={true}
                showCartBtn={false}
              />
            )}

            {isLoading ? (
              <ShimmerScreen case={"rect"} width={"100%"} height={"358px"} />
            ) : !_.isEmpty(headerProdData) && false ? (
              <DetailPageBannerHeaderComponent
                bannerURL={headerProdData?.banner}
                btnName={t("Purchase to unlock")}
                productData={headerProdData}
                showTagLine={!_.isEmpty(headerProdData.priceInfo.showText)}
                showShareIcon={true}
                showCartBtn={true}
                tagLine={`${headerProdData.priceInfo.showText}`}
                rightTagLine={`${
                  headerProdData.purchaseInfo.offer_ends_on_text
                    ? headerProdData.purchaseInfo.offer_ends_on_text
                    : ""
                }`}
                setIsMainPageLoading={() => {}}
              />
            ) : roleplayDetail?.reference_thumbnail ? (
              <>
                <div className="bannerrimg">
                <img
                  src={roleplayDetail.reference_thumbnail}
                  alt="Reference Thumbnail"
                  className="banner-image"
                />
              </div>

              </>
            ) : (
              <div className="title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center">
                <p
                  dangerouslySetInnerHTML={{
                    __html: roleplayDetail?.title,
                  }}
                ></p>
              </div>
            )}
          </div>
          <div className="container">
            <BreadCrumbComponent crumbList={breadCrumbData} />

            {sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" &&
            _.isEmpty(roleplayDetail) &&
            !isLoading ? (
              <img
                id="idRolePlayMyResponse"
                width={800}
                src="/images/myResponse.png"
                alt=""
              />
            ) : (
              <RPReviewDetailBodyComponent
                id={roleplayId}
                title={roleplayDetail?.title}
                logoURL={roleplayDetail?.provider?.provider_img}
                logoAltText={""}
                tagsArray={tagsArray}
                description={roleplayDetail?.description}
                productData={roleplayDetail}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setLoaderMsg={setLoaderMsg}
                rpData={""}
                type={type}
                rubricData={rubricData}
              />
            )}
            <div className="position-relative p-2 alert-btm">
              {/* {renderAlertCard()} */}
            </div>
          </div>
          <ConfirmModal
            confirmModal={confirmModal}
            setConfirmModal={setConfirmModal}
            showModalMsg={showModalMsg.message}
            isConfirm={false}
            confirmId={""}
            confirmAction={() => {}}
            isRightIcon={showGreenTick}
          />
        </>
      )}
    </>
  );
};

export default RolePlayReviewDetailComponent;
